import { render } from "./profileEditVisitedPlaceModal.vue?vue&type=template&id=0169a466&scoped=true"
import script from "./profileEditVisitedPlaceModal.vue?vue&type=script&lang=js"
export * from "./profileEditVisitedPlaceModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0169a466"

export default script